import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientTasks = ({ patientId, page = 1, rows = 25, searchTerm = "" }) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientTasks", tenantVal, patientId, page, rows, searchTerm],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const params = { page, rows };

      if (searchTerm && searchTerm.trim()) {
        params.searchTerm = searchTerm.trim();
      }

      const response = await axiosInstance.get(
        `${tenantVal}/task/getbypatientid/${patientId}`,
        { params }
      );

      return response.data;
    },
    enabled: !!tenantVal && !!patientId,
    meta: { errorMessage: "Error fetching patient tasks" },
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: true,
  });
};
